import React, { useContext, useState,useEffect } from "react";
import { TranslatorContext } from "../../context/Translator";
import { Link } from "react-router-dom";
import { Row, Col } from "react-bootstrap";
import PulseLoader from "react-spinners/PulseLoader";

import { FloatCardComponent } from "../../components/cards";
import ProductsTableComponent from "../../components/tables/ProductsTableComponent";
import LabelFieldComponent from "../../components/fields/LabelFieldComponent";
import { PaginationComponent } from "../../components";
import PageLayout from "../../layouts/PageLayout";
import drafts from "../../assets/data/verfied.json";
import { DraftTableComponent } from "../../components/tables";
import axios from "axios"
import { useLocation } from "react-router-dom";
export default function VerifiedFamilies() {

    const AuthToken = localStorage.getItem("AuthUser");
    const[loading,setLoading] = useState(false);
    const [data,setData] = useState([]);
    const location = useLocation();
    const search = location.search;
    useEffect(() => {
        const fetchData = async () => {
          try {
            setLoading(true);
            axios.defaults.headers.common["Authorization"] = `Bearer ${AuthToken}`;
            const response = await axios.get(
              process.env.REACT_APP_API_URL + "/verified-families"
            );
            setData(response.data.peoples);
            console.log("verified families",response.data.peoples);
            setLoading(false);
           
          } catch (error) {
            console.error("Error fetching data:", error);
          }
        };
    
        fetchData();
      }, [AuthToken]);
    const { t, n } = useContext(TranslatorContext)
    


    const mappedData = data.map((person) => ({
        id: person.person_id || "",
        fsf_id: person.f_number || "",
        beneficiary_cnic: person.cnic || "",
        beneficiary_name: person.beneficiary_name || "",
        partner_name: person.verifier_name || "", // Assuming the same name
        organization_church: person.identifier?.org || "",
       assesment_date: person.verification_date || "",
      
        total_loan_amount: person.est_loan_amount || 0,
       
        status: "Tested", // Static value, replace if dynamic
        action: {
          edit: "edit",
          delete: "delete",
          view: "visibility",
        },
      }));
    return (
        <PageLayout>
            <Row>
                <Col xl={12}>
                    <div className="mc-card">
                        <div className='mc-breadcrumb'>
                            <h3 className="mc-breadcrumb-title">{'Verified List'}</h3>
                            <ul className="mc-breadcrumb-list">
                                <li className="mc-breadcrumb-item"><Link to='#' className="mc-breadcrumb-link" style={{color:"#077834"}}>{t('home')}</Link></li>
                                <li className="mc-breadcrumb-item"><Link to='#' className="mc-breadcrumb-link" style={{color:"#077834"}}>{t('Families')}</Link></li>
                                <li className="mc-breadcrumb-item">{'Verified List'}</li>
                            </ul>
                        </div>
                    </div>
                </Col>
                {/* {floats.map((float, index) => (
                    <Col key={ index } sm={6} lg={3}>
                        <FloatCardComponent 
                            variant={ float.variant }
                            digit={n(float.digit)}
                            title={t(float.title)}
                            icon={ float.icon }
                        />
                    </Col>
                ))} */}


                {loading ? (<div
                                                className="d-flex justify-content-center align-items-center"
                                                style={{ height: "40vh", gap: "8px" }}
                                            >
                                                <h3
                                                    style={{
                                                        color: "#077834",
                                                        fontWeight: "bold",
                                                        letterSpacing: "1px",
                                                        marginBottom: "0",
                                                    }}
                                                >
                                                    Loading Data
                                                </h3>
                                                <PulseLoader
                                                    color="#077834"
                                                    loading={loading}
                                                    size={6}
                                                />
                                            </div>):  <Col xl={12}>
                    <div className="mc-card">
                        <Row>
                           
                            <Col xl={12}>
                                <DraftTableComponent 
                                    thead={ drafts.thead } 
                                    tbody={ mappedData } 
                                />
                                {/* <PaginationComponent /> */}
                            </Col>
                        </Row>
                    </div>
                </Col>}
               
            </Row>
        </PageLayout>
    );
}
